import React, { useContext } from 'react'
import { ContextService } from '../../../../../../contexts/serviceGralContext'
import SelectInput from '../../../../../../elements/SelectInput'
import { options } from './options'

function RoturaSelect() {

    const { currentService = {}, dinamicDataService, editDinamicServiceDataHandler } = useContext(ContextService)
    const valueForSelected = !!dinamicDataService?.ClosingDate ? currentService?.U_Rotura : dinamicDataService?.U_Rotura

    return (
        <SelectInput
            label="Rotura"
            name="U_Rotura"
            value={valueForSelected ?? ''}
            inputState={!!dinamicDataService?.ClosingDate}
            functEdit={e => !!dinamicDataService?.ClosingDate === false && editDinamicServiceDataHandler({ [e.target.name]: e.target.value })}
        >
            <option hidden>Elegir...</option>
            {options?.YESORNO.map(val => <option key={'rotura' + val}
                selected={valueForSelected == val}
                value={val}>{val}</option>)}
        </SelectInput>

    )
}

export default React.memo(RoturaSelect)